export const config = {
  connectionString:
    process.env['NEXT_PUBLIC_APPLICATIONINSIGHTS_CONNECTION_STRING'] ?? '',
};
